import { ARTIST_NAME, ARTIST_EMAIL, ALBUM_TITLE, SPOTIFY_ALBUM_URL } from "./siteData";

const Section = ({ title, children, testid }) => (
  <section data-testid={testid} className="space-y-3">
    <h2 className="text-xs font-mono-code text-[#818cf8] uppercase tracking-widest">{title}</h2>
    {children}
  </section>
);

export const PressKit = () => (
  <div data-testid="press-page" className="min-h-screen bg-[#090a0f] text-[#eceef2] antialiased">
    <div className="max-w-3xl mx-auto px-6 py-16 space-y-12">
      <header className="flex flex-col sm:flex-row gap-8 items-start">
        <img
          src="/press-cover.jpg"
          alt={`Copertina dell'album ${ALBUM_TITLE} di Andrea Kim Bertone`}
          data-testid="press-cover-image"
          className="w-40 h-40 rounded-2xl object-cover border border-[#2a3048] shrink-0"
        />
        <div className="space-y-3">
          <span className="text-xs font-mono-code text-[#818cf8] uppercase tracking-widest">PRESS KIT</span>
          <h1 className="font-disp font-extrabold text-3xl md:text-4xl text-white tracking-tight">{ARTIST_NAME}</h1>
          <p className="font-serif-body text-[#94a3b8] leading-relaxed">
            Compositore di colonne sonore elettroniche digitali e sound designer per cortometraggi, film indipendenti e
            opere visive. Laureato in Graphic Design.
          </p>
        </div>
      </header>

      <Section title="BIO" testid="press-bio">
        <p className="font-serif-body text-[#cbd5e1] leading-relaxed">
          {ARTIST_NAME} crea colonne sonore elettroniche con un suono originale e riconoscibile, costruito in anni di
          lavoro nel sound design elettronico. La formazione in graphic design plasma un approccio sinestetico: la
          musica come struttura architetturale sincronizzata con la fotografia e il ritmo di montaggio del regista.
        </p>
      </Section>

      <Section title="DISCOGRAFIA" testid="press-discography">
        <div className="rounded-2xl bg-[#111320] border border-[#212638] p-5 space-y-2">
          <p className="font-disp font-bold text-white">{ALBUM_TITLE}</p>
          <p className="text-sm font-serif-body text-[#94a3b8]">Album &bull; 17 tracce &bull; distribuito su Spotify tramite DistroKid</p>
          <a
            href={SPOTIFY_ALBUM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="press-spotify-link"
            className="inline-block text-xs font-mono-code text-[#a5b4fc] hover:text-white transition-colors"
          >
            {SPOTIFY_ALBUM_URL}
          </a>
        </div>
      </Section>

      <Section title="AREE DI LAVORO" testid="press-services">
        <ul className="font-serif-body text-[#cbd5e1] space-y-1.5 list-disc list-inside">
          <li>Colonne sonore originali per cortometraggi e film indipendenti</li>
          <li>Sound design elettronico per opere visive e installazioni artistiche</li>
          <li>Composizione su commissione con vocabolario sonoro creato da zero per ogni progetto</li>
        </ul>
      </Section>

      <Section title="CONTATTI" testid="press-contacts">
        <div className="rounded-2xl bg-[#111320] border border-[#212638] p-5 space-y-2 text-sm font-mono-code">
          <p>
            <span className="text-[#64748b]">Email: </span>
            <a href={`mailto:${ARTIST_EMAIL}`} data-testid="press-email-link" className="text-[#a5b4fc] hover:text-white transition-colors">
              {ARTIST_EMAIL}
            </a>
          </p>
          <p>
            <span className="text-[#64748b]">Web: </span>
            <a href="/" data-testid="press-site-link" className="text-[#a5b4fc] hover:text-white transition-colors">
              Torna al sito
            </a>
          </p>
        </div>
      </Section>

      <div className="no-print pt-4 flex flex-wrap gap-4">
        <button
          type="button"
          data-testid="press-download-button"
          onClick={() => window.print()}
          className="px-7 py-3.5 rounded-xl bg-[#6366f1] text-white text-sm font-disp font-bold shadow-lg shadow-indigo-950/60 hover:bg-[#4f46e5] transition-colors"
        >
          Scarica Press Kit (PDF)
        </button>
        <a
          href="/"
          data-testid="press-back-link"
          className="px-6 py-3.5 rounded-xl border border-[#2d334d] text-white text-sm font-disp font-medium hover:bg-[#161926] transition-colors"
        >
          Torna al sito
        </a>
      </div>
    </div>
  </div>
);
